import React, { useState } from 'react';
import {
    ButtonActionEmphasis,
    FooterOrigination,
    HeaderOrigination,
} from '@honeycomb-npm/honeycomb-react';
import Info from '../components/Info';
import { ErrorMessage } from '@honeycomb-npm/honeycomb-react';
import { useNavigate } from 'react-router-dom';
import { size, toLower } from 'lodash';
import './PaymentTracker.scss';
import PaymentTrackerDetailsView from './PaymentTrackerDetailsView';

function PaymentTracker() {
    const [paymentTrackingNumber, setPaymentTrackingNumber] = useState('');
    const [isPaymentTrackingValid, setPaymentTrackingValid] = useState(true);
    const [isPaymentTrackingEmpty, setPaymentTrackingEmpty] = useState(false);
    const history = useNavigate();
    const params = new URL(document.location).searchParams;
    const paymentTrackingNumberFromURL = params.get('UETR');
    const REGEX = {
        UETR: /^[0-9a-zA-Z]{8}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{12}$/,
    };
    const emptyFieldMessage = 'Enter a payment tracking reference';
    const invalidFormatMessage = 'Only enter letters, numbers and a dash, in the format XXXXXXXX‑XXXX-XXXX‑XXXX‑XXXXXXXXXXXX';
    const handlePaymentTrackingNumber = (event) => {
        setPaymentTrackingNumber(toLower(event.target.value));
        setPaymentTrackingEmpty(false);
    };
    const clearPaymentTrackingNumber = () => {
        setPaymentTrackingNumber('');
        setPaymentTrackingValid(true);
        setPaymentTrackingEmpty(false);
    };
    const handleClick = () => {
        const testValue = REGEX.UETR;
        const validValue = testValue.test(paymentTrackingNumber);

        if (size(paymentTrackingNumber) > 0) {
            if (!validValue) {
                setPaymentTrackingValid(false);
            } else {
                setPaymentTrackingValid(true);
                history(`?UETR=${paymentTrackingNumber}`);
            }
        } else {
            setPaymentTrackingEmpty(true);
        }
    };

    return (
        <div>
            {!paymentTrackingNumberFromURL ? (
                <div
                    className="app h100vh honeycomb textstyles--commbank"
                    id="StartMainContent"
                >
                    <HeaderOrigination
                        href="https://www.commbank.com.au/"
                    />
                    {/* for View */}
                    <div className="d-flex flex-column flex-grow-1 px-0">
                        <div className="flex-grow-1 honeycomb textstyles--netbank px-0">
                            <div className="scrollable-form container customer-onboarding-typeform container-padding">
                                <div className="container validate-card-page-container">
                                    <div className="row ">
                                        <div className="col-12 mt-0">
                                            <h1 className="mb-2">Track your payment</h1>
                                            <p className="mb-3">
                                                Enter your payment tracking reference to track your
                                                international payment.
                                            </p>
                                        </div>
                                        <div className="col-12 mb-1">
                                            <div className="form-group">
                                                <label htmlFor="PaymentTrackingNumber">
                                                    <div className="col-12 mx-0 px-0 mb-1">
                                                        Payment tracking reference
                                                    </div>
                                                    <div className="form-field__with-btn col-12 col-lg-5 col-md-8 mx-0 px-0">
                                                        <input
                                                            id="PaymentTrackingNumber"
                                                            className={
                                                                isPaymentTrackingEmpty || !isPaymentTrackingValid
                                                                    ? 'form-control is-invalid'
                                                                    : 'form-control'
                                                            }
                                                            name="PaymentTrackingNumber"
                                                            type="text"
                                                            maxLength={36}
                                                            placeholder="XXXXXXXX‑XXXX-XXXX‑XXXX‑XXXXXXXXXXXX "
                                                            value={paymentTrackingNumber}
                                                            aria-describedby="PaymentTrackingNumber-helptext"
                                                            onChange={(e) => {
                                                                handlePaymentTrackingNumber(e);
                                                            }}
                                                        />
                                                        {isPaymentTrackingEmpty && (
                                                            <ErrorMessage
                                                                forceVisible
                                                                className="error-message"
                                                                iconType="svgfile"
                                                                id="emptyField"
                                                                message={emptyFieldMessage}
                                                            />
                                                        )}
                                                        {!isPaymentTrackingValid && !isPaymentTrackingEmpty && (
                                                            <ErrorMessage
                                                                forceVisible
                                                                className="error-message"
                                                                iconType="svgfile"
                                                                id="invalidField"
                                                                message={invalidFormatMessage}
                                                            />
                                                        )}
                                                        <button
                                                            className="icon-wrapper btn-action-formfield"
                                                            type="button"
                                                            data-testid="clear-text"
                                                            onClick={clearPaymentTrackingNumber}
                                                        >
                                                            <i
                                                                className="iconControlClose24"
                                                                aria-hidden="true"
                                                            />
                                                            <span className="sr-only">clear text</span>
                                                        </button>
                                                    </div>
                                                </label>
                                                <p className="Text16Left commbankBlack">You can find this on your payment details</p>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-9 mb-5">
                                            <Info />
                                        </div>
                                        <div className="col-12">
                                            <ButtonActionEmphasis
                                                type="button"
                                                variant="emphasis"
                                                onClick={handleClick}
                                            >
                                                Track payment
                                            </ButtonActionEmphasis>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <FooterOrigination />
                    </div>
                </div>
            )
                : (<PaymentTrackerDetailsView paymentTrackingNumber={paymentTrackingNumberFromURL} />)}
        </div>
    );
}
export default PaymentTracker;
